module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "keyboard",
    style: ('margin-top:' + _vm.fillingNum + 'px')
  }, [_c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 0,
      "left": 374,
      "label": _vm.labelUp,
      "arrow": "translate(0, 63px)",
      "position": true,
      "active": _vm.keyboard['up']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onUpStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onUpStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onUpEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 180,
      "left": 374,
      "label": _vm.labelDown,
      "arrow": "translate(0,-71px) rotate(180deg)",
      "active": _vm.keyboard['down']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onDownStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onDownStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onDownEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 284,
      "label": _vm.labelLeft,
      "arrow": "translate(60px, -12px) rotate(270deg)",
      "active": _vm.keyboard['left']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onLeftStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onLeftStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onLeftEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s1",
      "top": 90,
      "left": 464,
      "label": _vm.labelRight,
      "arrow": "translate(-60px, -12px) rotate(90deg)",
      "active": _vm.keyboard['right']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onRightStart.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onRightStart.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onRightEnd.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "red",
      "size": "s2",
      "top": 0,
      "left": 196,
      "label": _vm.labelResetR,
      "active": _vm.keyboard['reset']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onResetDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onResetDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onResetUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 106,
      "label": _vm.labelSoundS,
      "active": _vm.keyboard['music']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onMusicDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onMusicDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onMusicUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "green",
      "size": "s2",
      "top": 0,
      "left": 16,
      "label": _vm.labelPauseP,
      "active": _vm.keyboard['pause']
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onPauseDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onPauseDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onPauseUp.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('vbutton', {
    attrs: {
      "color": "blue",
      "size": "s0",
      "top": 100,
      "left": 52,
      "label": 'GO',
      "active": false
    },
    nativeOn: {
      "touchstart": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onGoDown.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.onGoDown.apply(null, arguments)
      },
      "touchend": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      },
      "mouseup": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      },
      "mouseleave": function($event) {
        return _vm.onGoUp.apply(null, arguments)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0118c1ee","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/keyboard/index.vue
// module id = 150
// module chunks = 1